import { IRootState } from '../../../store'
import { IPatientImmunizationsState } from '../store/patientImmunizations.types'

export const getPatientImmunizationsSelector = (state: IRootState): IPatientImmunizationsState =>
  state.patientImmunizations
